import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Services.css';

const Services = () => {
  const navigate = useNavigate();

  const services = [
    {
      icon: '💼',
      title: 'Business Consulting',
      description: 'Strategic advice and solutions to help your business grow and succeed in a competitive market.',
      path: '/services/business-consulting'
    },
    {
      icon: '📊',
      title: 'Financial Planning',
      description: 'Comprehensive financial strategies and analysis to optimize your business operations and profitability.',
      path: '/services/financial-planning'
    },
    {
      icon: '🎯',
      title: 'Project Management',
      description: 'Professional project oversight and execution to ensure your initiatives are completed on time and within budget.',
      path: '/services/project-management'
    },
    {
      icon: '🤝',
      title: 'Partnership Development',
      description: 'Building strategic partnerships and relationships that drive mutual success and business growth.',
      path: '/services/partnership-development'
    },
    {
      icon: '📈',
      title: 'Market Analysis',
      description: 'In-depth market research and analysis to identify opportunities and stay ahead of industry trends.',
      path: '/services/market-analysis'
    },
    {
      icon: '⚙️',
      title: 'Operational Excellence',
      description: 'Streamlining processes and implementing best practices to enhance efficiency and productivity.',
      path: '/services/operational-excellence'
    }
  ];

  return (
    <section id="services" className="services">
      <div className="services-container">
        <div className="section-header">
          <h2 className="section-title">Our Services</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">Comprehensive Solutions for Your Business Needs</p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="service-card"
              onClick={() => navigate(service.path)}
            >
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <div className="service-link">
                Learn More →
              </div>
            </div>
          ))}
        </div>

        <div className="services-cta">
          <h3>Ready to Get Started?</h3>
          <p>Let's discuss how we can help your business achieve its goals.</p>
          <button className="btn btn-primary" onClick={() => {
            const element = document.getElementById('contact');
            if (element) element.scrollIntoView({ behavior: 'smooth' });
          }}>
            Contact Us Today
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;

